<div class="mt-5">
  <ng-container *ngIf="historyList.length > 0; else noList">
    <div class="table-container">
      <div class="table-wrapper">
        <table class="modern-table">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Invoice No.</th>
              <th>Service</th>
              <th>Branch</th>
              <th>Phone No.</th>
              <th>No. of Boxes</th>
              <th>Consignee Name</th>
              <th *ngIf="hasAction" class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of historyList" class="table-row">
              <td>
                <div class="invoice-cell">
                  <mat-icon class="branch-icon">date_range</mat-icon>
                  <span class="invoice-number">{{ item.OrderDate | date:'MMM dd, yyyy' }}</span>
                </div>
              </td>
              <td>
                <div class="invoice-cell">
                  <mat-icon class="invoice-icon">receipt</mat-icon>
                  <span class="invoice-number">{{ item.InvoiceNo }}</span>
                </div>
              </td>
              <td>
                <div class="service-cell">
                  <span class="service-label">Type:</span>
                  <span class="service-value">{{ item.ServiceTypeCode }}</span>
                </div>
              </td>
              <td>
                <div class="branch-cell">
                  <mat-icon class="branch-icon">store</mat-icon>
                  <span>{{ item.BranchName }}</span>
                </div>
              </td>
              <td>
                <div class="phone-cell">
                  <mat-icon class="phone-icon">phone</mat-icon>
                  <span>{{ item.PhoneNumber }}</span>
                </div>
              </td>
              <td>
                <div class="boxes-badge">
                  <span>{{ item.NoOfBoxes || 0 }}</span>
                </div>
              </td>
              <td>
                <div class="consignee-cell">
                  <mat-icon class="consignee-icon">person</mat-icon>
                  <span
                    >{{ item.ConsigneeName }} {{ item.ConsigneeLastName }}</span
                  >
                </div>
              </td>
              <td *ngIf="hasAction" class="action-cell">
                <button
                  *ngIf="item.LastSorefStatusCode == 'PENDING'"
                  mat-raised-button
                  class="btn-pending"
                  disabled
                >
                  <mat-icon>pending</mat-icon>
                  <span>PENDING</span>
                </button>

                <button
                  *ngIf="item.IsPaid"
                  mat-raised-button
                  class="btn-view"
                  (click)="viewTransactionDetails(item)"
                >
                  <mat-icon>visibility</mat-icon>
                  <span>View</span>
                </button>

                <button
                  *ngIf="!item.IsPaid && item.LastSorefStatusCode !== 'PENDING'"
                  mat-raised-button
                  class="btn-pay"
                  (click)="onPayment(item)"
                >
                  <mat-icon>payment</mat-icon>
                  <span>Pay Now</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <ng-template #noList>
    <div class="no-data-container">
      <div class="no-data-content">
        <mat-icon class="no-data-icon">inbox</mat-icon>
        <h2 class="no-data-title">No Transactions</h2>
        <p class="no-data-subtitle">
          Your transaction history will appear here
        </p>
      </div>
    </div>
  </ng-template>
</div>
